import { useQuery } from "@tanstack/react-query";
import { fetchCountries } from "../../config/apisauce";

const useCountriesQuery = ({ role, status, isPaginated, perPage }) => {
  const params = { role, status, isPaginated, perPage };

  return useQuery({
    queryKey: ["countries", "users", params],
    queryFn: async () => await fetchCountries(params),
    staleTime: 1000 * 60 * 10, // 10 minutes in milliseconds
  });
};

export default useCountriesQuery;
